import { render, staticRenderFns } from "./fromtype.vue?vue&type=template&id=53892430&scoped=true&"
import script from "./fromtype.vue?vue&type=script&lang=js&"
export * from "./fromtype.vue?vue&type=script&lang=js&"
import style0 from "./fromtype.vue?vue&type=style&index=0&id=53892430&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53892430",
  null
  
)

export default component.exports